<template>
  <div>
    <LvChecklistCollapseList
      v-for="(
        record, recordIndex
      ) in recordList"
      :key="recordIndex"
      :record-data="record"
      :title="'YYYY'"
      :sub-title="'2022. Q5 (11-1)'"
      class="w-full"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      recordList: [
        {
          date: "2022-11-01",
          systemClassIcon:
            "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970289062siFK/%E7%92%B0%E4%BF%9D.png?signature=542130fa0b741fd0b28f9f9c599335cf4d387559971729a8ac9451fda349c61f",
          systemClass: "環保",
          systemClassId: 4,
          recordDataTable: {
            columnHeader: [
              {
                id: "result",
                textLabel: "結果",
                type: "icon",
                tabletHide: false,
                width: "5%",
              },
              {
                id: "subCategory",
                textLabel: "子領域",
                type: "chips",
                tabletHide: false,
                width: "15%",
              },
              {
                id: "name",
                textLabel: "名稱",
                type: "text",
                tabletHide: false,
                overflowHide: true,
                width: "40%",
              },
              {
                id: "compliance",
                textLabel: "合規率",
                type: "text",
                tabletHide: true,
                width: "5%",
              },
              {
                id: "checker",
                textLabel: "答題者",
                type: "text",
                tabletHide: false,
                width: "5%",
              },
              {
                id: "date",
                textLabel: "填表日期",
                type: "text",
                tabletHide: true,
                width: "10%",
              },
              {
                id: "reviewer",
                textLabel: "覆核者",
                type: "text",
                tabletHide: true,
                width: "5%",
              },
              {
                id: "condition",
                textLabel: "狀態",
                type: "text",
                tabletHide: true,
                width: "10%",
              },
              {
                id: "download",
                icon: "icon-cloud-download",
                textLabel: "匯出",
                type: "downloadPopup",
                tabletHide: true,
              },
            ],
            rowData: [],
          },
          unRecordDataTable: {
            columnHeader: [
              {
                id: "subCategory",
                textLabel: "子領域",
                type: "chips",
                tabletHide: false,
                width: "10%",
              },
              {
                id: "name",
                textLabel: "名稱",
                type: "text",
                tabletHide: false,
                overflowHide: true,
                width: "70%",
              },
              {
                id: "checker",
                textLabel: "答題者",
                type: "text",
                tabletHide: false,
                width: "20%",
              },
            ],
            rowData: [
              {
                id: 561,
                subCategory: [
                  {
                    name: "空氣污染防制",
                    leadingIcon:
                      "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
                  },
                ],
                name: "固定污染源自行檢查表appppp",
                checker: "蔡A辣,馬敏源,曹阿毛",
              },
            ],
          },
        },
      ],
    }
  }
}
</script>